<template>
  <div class="assets-map">
    <leaflet-map
      :id="mapId"
      :center="center"
      :height="mapHeight"
      :markers="markers"
      @click-map="onClickMap"
      :lines="lines"
      @click-line="onClickLine"
      :polygons="polygons"
      @click-polygon="onClickPolygon"
      :circles="circles"
      @click-circle="onClickCircle"
      :drawable="drawable"
      @draw-created="onDrawCreated"
      ref="leafletMap"
    ></leaflet-map>
  </div>
</template>

<script>
import LeafletMap from "@/components/LeafletMap";

export default {
  props: {
    assets: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Object,
      default: () => {}
    },
    markers: {
      type: Array,
      default: () => []
    },
    mapId: {
      type: String
    },
    mapHeight: {
      type: Number
    },
    drawable: {
      type: Boolean
    }
  },
  components: {
    LeafletMap
  },
  computed: {
    center() {
      if (this.selected) {
        // Not final. Still need to determine the center if the asset is a line/polygon.
        const node = this.selected.assetNodes[0];

        return {
          lat: node.latitude,
          lng: node.longitude
        };
      }

      return undefined;
    },
    circles() {
      return this.assets.reduce((acc, asset) => {
        if (asset.assetNodes.length === 1) {
          let latLng = null;
          let options = {
            id: asset.id
          };

          if (asset.options) {
            // Place color to fillColor attribute
            const { color, ...rest } = asset.options;

            options = {
              ...options,
              ...rest,
              fillColor: color
            };
          }

          asset.assetNodes.forEach(node => {
            latLng = [node.latitude, node.longitude];
          });

          acc.push({
            latLng,
            hoverEvent: {
              content: this.hoverEventContent(asset)
            },
            options,
            active: this.selected && this.selected.id === asset.id
          });
        }

        return acc;
      }, []);
    },
    lines() {
      return this.assets.reduce((acc, asset) => {
        if (asset.assetNodes.length === 2) {
          let latLngs = [];
          let options = {
            id: asset.id
          };

          if (asset.options) {
            options = {
              ...options,
              ...asset.options
            };
          }

          asset.assetNodes.forEach(node => {
            latLngs.push([node.latitude, node.longitude]);
          });

          acc.push({
            latLngs,
            hoverEvent: {
              content: this.hoverEventContent(asset)
            },
            options,
            active: this.selected && this.selected.id === asset.id
          });
        }

        return acc;
      }, []);
    },
    polygons() {
      return this.assets.reduce((acc, asset) => {
        if (asset.assetNodes.length > 2) {
          let latLngs = [];
          let options = {
            id: asset.id
          };

          if (asset.options) {
            options = {
              ...options,
              ...asset.options
            };
          }

          asset.assetNodes.forEach(node => {
            latLngs.push([node.latitude, node.longitude]);
          });

          acc.push({
            latLngs,
            hoverEvent: {
              content: this.hoverEventContent(asset)
            },
            options,
            active: this.selected && this.selected.id === asset.id
          });
        }

        return acc;
      }, []);
    }
  },
  watch: {
    assets: {
      handler: function() {
        this.$nextTick(() => {
          this.loadMapObjects();
        });
      },
      deep: true
    },
    selected() {
      this.$nextTick(() => {
        this.loadMapObjects();
      });
    },
    center(value) {
      if (value) {
        this.$nextTick(() => {
          this.$refs.leafletMap.resetView();
        });
      }
    },
    markers: {
      handler: function() {
        this.$nextTick(() => {
          this.loadMapObjects();
        });
      },
      deep: true
    }
  },
  methods: {
    loadMapObjects() {
      this.$refs.leafletMap.clearLayers();
      this.$refs.leafletMap.loadLines();
      this.$refs.leafletMap.loadPolygons();
      this.$refs.leafletMap.loadCircles();
      this.$refs.leafletMap.loadMarkers();
    },
    hoverEventContent(asset) {
      let hoverData = document.createElement("div");

      hoverData.innerHTML = `
        <span><b>SAP ID</b>: ${asset.thirdPartyCode || "N/A"}</span>
        <br>
        <span><b>ASSET TYPE</b>: ${asset.code ? asset.code.code : "N/A"}</span>
      `;

      return hoverData;
    },
    onClickMap(event) {
      this.$emit("click", event);
    },
    onClickCircle(event) {
      this.updateSelected(event.target.options.id);
    },
    onClickLine(event) {
      this.updateSelected(event.target.options.id);
    },
    onClickPolygon(event) {
      this.updateSelected(event.target.options.id);
    },
    updateSelected(id) {
      const selected = this.assets.find(asset => asset.id === id);
      this.$emit("update:selected", selected);
    },
    onDrawCreated(event) {
      this.$emit("draw-created", event);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetsMap.vue